import { render, staticRenderFns } from "./PersonScore.vue?vue&type=template&id=7f98ede1&scoped=true&"
import script from "./PersonScore.vue?vue&type=script&lang=js&"
export * from "./PersonScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f98ede1",
  null
  
)

export default component.exports